var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext } from 'react';
import { useFormsContext } from '@ally/forms';
import { TransferSpeedsContext, } from './useTransferSpeeds';
import { isLoading, RemoteStatus } from './Remote';
import { useComputedValues } from './useComputedValues';
export var useTransferFormsContext = function () {
    var formsContext = useFormsContext();
    var _a = useContext(TransferSpeedsContext), transferSpeeds = _a.transferSpeeds, withdrawalDate = _a.withdrawalDate;
    var shouldDisableSubmit = isLoading([transferSpeeds, withdrawalDate]) ||
        transferSpeeds.status === RemoteStatus.Failed;
    var accountRestrictionError = transferSpeeds.status === RemoteStatus.Failed
        ? transferSpeeds.error.message
        : undefined;
    var _b = useComputedValues(), fromAccount = _b.fromAccount, toAccount = _b.toAccount, isIraPaperForm = _b.isIraPaperForm, isIraWithdrawal = _b.isIraWithdrawal;
    return __assign(__assign({}, formsContext), { meta: {
            transferSpeeds: transferSpeeds,
            withdrawalDate: withdrawalDate,
            shouldDisableSubmit: shouldDisableSubmit,
            accountRestrictionError: accountRestrictionError,
            fromAccount: fromAccount,
            toAccount: toAccount,
            isIraPaperForm: isIraPaperForm,
            isIraWithdrawal: isIraWithdrawal,
        } });
};
//# sourceMappingURL=useTransferFormsContext.js.map